module.exports = __webpack_public_path__ + "fc8abde3470fd554df2e7d098682f18d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/gamers-paradise-empty.png
// module id = 319
// module chunks = 0